exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gjmA {\n    width: 100%;\n    border: 1px solid #e4e8eb;\n    border-radius: 6px;\n    background-color: white;\n    text-align: center;\n}\n\n._27H7 {\n    text-align: center;\n    margin: 20px 0;\n    padding: 0 20px;\n}\n\n._3wMW {\n    margin: 0;\n}\n\n._2kJq {\n    margin: 20px !important;\n}\n\n._3iQQ {\n    text-align: left;\n}\n\n.hWyw {\n    margin: auto 20px 0 20px;\n}\n\n._2IFR > * {\n    font-size: 18px;\n}\n\n@media (min-width: 1176px) {\n    .gjmA {\n        width: 320px;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"container": "gjmA",
	"chatNow": "_27H7",
	"chatNowExternal": "_3wMW",
	"separatorExternal": "_2kJq",
	"left": "_3iQQ",
	"separator": "hWyw",
	"degreeName": "_2IFR"
};